import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FilterState } from "@/components/shared/unified-filter-menu/filter-state";
import { Observable } from "rxjs";
import { RadioOption } from "@/components/shared/radio-list/radio-list.component";
import { AppDialogRef, provideAppDialogRef } from "@/_services/app-dialog-ref";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";

export interface ExportDialogResult {
    format: ExportStatsFormat;
    filterStates: FilterState[];
}

export type ExportStatsFormat = "csv" | "pdf" | "html";

export interface PdfConfirmExportData {
    currentFilters: Record<string, unknown>;
    userList$: Observable<RadioOption[]>;
    aircraftList$: Observable<RadioOption[]>;
    formList$: Observable<RadioOption[]>;
}

@Component({
    selector: "app-pdf-confirm-export",
    templateUrl: "./pdf-confirm-export.component.html",
    styleUrls: ["./pdf-confirm-export.component.scss"],
    standalone: true,
    imports: [CommonModule, SharedComponentsModule],
    providers: [provideAppDialogRef<ExportStatsFormat, PdfConfirmExportData>()],
})
export class PdfConfirmExportComponent implements OnInit {
    currentFilters: { key: string; value: any }[] = [];
    userList$: Observable<RadioOption[]>;
    aircraftList$: Observable<RadioOption[]>;
    formList$: Observable<RadioOption[]>;

    constructor(
        public dialogRef: AppDialogRef<ExportStatsFormat, PdfConfirmExportData>,
    ) {}

    ngOnInit() {
        const data = this.dialogRef.data;
        this.userList$ = data.userList$;
        this.aircraftList$ = data.aircraftList$;
        this.formList$ = data.formList$;

        this.currentFilters = Object.entries(data.currentFilters)
            .filter(([key, value]: [string, any]) => {
                if (key === "timeFrame") {
                    return false;
                }
                if (key === "airport") {
                    return value._id;
                }
                if (key === "flightDate") {
                    return value.length;
                }
                return value;
            })
            .map(([key, value]) => {
                return { key: key, value: value };
            });
    }

    close() {
        this.dialogRef.close();
    }

    confirmExport(format: ExportStatsFormat) {
        this.dialogRef.close(format);
    }
}
